import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Column } from "@core/models/datables";
import { TranslateService } from "@ngx-translate/core";
import { Density } from "@ryd/models/density";
import { environment } from "environments/environment";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class DensityService {
    private lang: string = this._translateService.currentLang;
    private columns: Column[];

    /**
         * 
         * @param _http 
         */
    constructor(
        private _http: HttpClient,
        private _translateService: TranslateService) { }

    getAll() {
        return this._http.get<Density[]>(`${environment.rydApiUrl}/api/density`);
    }


    saveDensity(density: Density) {
        return this._http.post<Density>(`${environment.rydApiUrl}/api/density`, density)
            .pipe(
                map((response: any) => response.density as Density),
                catchError(e => {
                    return throwError(e);
                })
            );
    }

    updateDensity(density: Density) {
        return this._http.post<Density>(`${environment.rydApiUrl}/api/density/${density.id}`, density)
            .pipe(
                map((response: any) => response.density as Density),
                catchError(e => {
                    return throwError(e);
                })
            );
    }

    deleteDensity(density: Density, statusId) {
        return this._http.put<Density>(`${environment.rydApiUrl}/api/density/${density.id}/${statusId}`, {})
            .pipe(
                map((response: any) => response.density as Density),
                catchError(e => {
                    return throwError(e);
                })
            );
    }

    /**
    * search for desired density
    * @param brix 
    * @returns found entity
    */
    findByBrix(brix: number) {
        return this._http.get<Density>(`${environment.rydApiUrl}/api/density/${brix}`).toPromise();
    }

}
